var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHealthSafetyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2765",
    "data-name": "Group 2765",
    transform: "translate(-8808 -2724)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_76",
    "data-name": "Ellipse 76",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(8808 2724)",
    fill: "#1b62ab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2805",
    "data-name": "Group 2805",
    transform: "translate(8749.578 2735.141)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1751",
    "data-name": "Path 1751",
    d: "M90.979,31.445c-1.119,1.067-2.316,2.108-3.643,3.149V9.171h9.29l3.539,4.268a26.477,26.477,0,0,1-.7,4.059,9.073,9.073,0,0,1,1.874.52,32.6,32.6,0,0,0,.807-4.814.98.98,0,0,0-.208-.7L95.117,4.279a.938.938,0,0,0-.755-.338H80.311a1.024,1.024,0,0,0-.755.338L72.764,12.5a.946.946,0,0,0-.208.7C73.311,22.26,77.942,29.91,86.764,36.6a1.032,1.032,0,0,0,.572.208.909.909,0,0,0,.572-.208,48.18,48.18,0,0,0,4.372-3.721,11.514,11.514,0,0,1-1.3-1.431Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1752",
    "data-name": "Path 1752",
    d: "M382.02,251.56a7.52,7.52,0,1,0,7.52,7.52A7.507,7.507,0,0,0,382.02,251.56Zm0,13.089a5.569,5.569,0,1,1,5.569-5.569A5.575,5.575,0,0,1,382.02,264.649Z",
    transform: "translate(-283.99 -232.892)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1753",
    "data-name": "Path 1753",
    d: "M434.442,309.123v-3.3h-1.952v3.3h-3.3v1.952h3.3v3.3h1.952v-3.3h3.3v-1.952Z",
    transform: "translate(-335.423 -283.923)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthSafetyIcon);
export default __webpack_public_path__ + "static/media/health-safety-icon.74201b60.svg";
export { ForwardRef as ReactComponent };